import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { AppConfig } from "app/app.config";
import { APIService } from 'app/services/api.service';
import { apiTokenProviderType } from "app/modules/account/loginCore.component";
import { LoaderService } from 'app/services/loader.service';
import { authUserType } from "app/services/auth.service";
import { PincodeInputComponent } from '../pincode-input/pincode-input.component';
import { NgClass } from '@angular/common';

type tokenProviderType = apiTokenProviderType & {
  text: string;
  type: string;
};

type errorType = {
  CurrentAttempt?: number;
  LockOutEndsMessage?: string;
  MaxAttempt?: number;
  UserMessage: string;
};

@Component({
    selector: 'nwm-tfa',
    templateUrl: './tfa.component.html',
    styleUrls: ['./tfa.component.scss'],
    imports: [PincodeInputComponent, NgClass]
})

export class NWMTfaComponent implements OnInit {
  private api = inject(APIService);
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);

  @Input() providers: apiTokenProviderType[] = [];
  @Input() isLogin = false;
  @Input() isPasswordReset = false;
  @Input() IsForgotUsernamePassword = false;
  @Output() timeOut : EventEmitter<errorType>;
  @Output() tfaSuccess : EventEmitter<authUserType>;
  public selectedProvider?: tokenProviderType;
  public altProvider?: tokenProviderType;
  public hasPhoneOption = false;
  public codeSlider = false;
  public helpSlider = false;

  public resent = false;

  errorMsg = '';
  errorAttempts=false;

  rememberMe = false;

  code = "";
  codePattern = /^[0-9]{6}$/;
  codeValid = false;

  constructor() {
    this.timeOut = new EventEmitter<errorType>();
    this.tfaSuccess = new EventEmitter<authUserType>();
  }

  ngOnInit() {
    this.setProviders(this.providers);
    this.sendTfaCode();
  }

  setProviders(providers: apiTokenProviderType[]) {
    providers.forEach(p => {
      if (p.IsActive || p.Name == 'Email Code') {
        const provider = p.IsActive && !this.selectedProvider ? 'selectedProvider' : 'altProvider';
        this[provider] = {
          ...p,
          text: p.Name == 'Phone Code' ? p.PhoneNumber : p.Email as string,
          type: p.Name == 'Phone Code' ? 'phone' : 'email',
        };
        this.hasPhoneOption = this.hasPhoneOption || p.Name == 'Phone Code';
      }
    });
    if (!this.selectedProvider && this.altProvider) {
      this.selectedProvider = this.altProvider;
      this.altProvider = undefined;
    }
  }

  sendTfaCode() {
    type bodyType = {
      provider: string;
      username?: string;
    };
    this.errorAttempts=false;
    this.errorMsg = '';
    this.code = '';
    this.codeSlider = false;
    this.helpSlider = false;
    if (this.selectedProvider) {
      const body: bodyType = { provider: this.selectedProvider.Name };
      const username = sessionStorage.getItem('2fa_username');
      if (username) body.username = username;
      this.loaderService.display(true);
      this.api.post(this.config.login.sendCodeUrl, body, {withCredentials: true}).subscribe(
        () => {
          this.loaderService.display(false);
        },
        error => {
          this.handleSubmitError(error.error);
          this.loaderService.display(false);
        }
      );
    }
  }

  resend(provider: tokenProviderType) {
    this.resent=true;
    this.code = '';
    if (provider != this.selectedProvider) {
      this.altProvider = this.selectedProvider;
      this.selectedProvider = provider;
    }
    this.sendTfaCode();
  }

  verifyCode() {
    type bodyType = {
      code: string;
      IsForgotUsernamePassword: boolean;
      IsPasswordReset: boolean;
      provider?: string;
      rememberme: boolean;
      username?: string;

    };
    const body: bodyType = {
      code: this.code,
      IsForgotUsernamePassword: this.IsForgotUsernamePassword,
      IsPasswordReset: this.isPasswordReset,
      provider: this.selectedProvider?.Name,
      rememberme: this.rememberMe,
    };
    const username = sessionStorage.getItem('2fa_username');
    if (username) body.username = username;
    this.loaderService.display(true);
    this.api.post<authUserType>(this.config.login.verifyCodeUrl, body, {withCredentials: true}).subscribe(
      data => {
        this.tfaSuccess.emit(data);
        this.loaderService.display(false);
      },
      error => {
        this.handleSubmitError(error.error);
        this.loaderService.display(false);
      }
    );
  }

  codeChange(e: string) {
    this.code = e;
    this.codeValid = this.codePattern.test(this.code);
  }

  handleRememberMe() {
    this.rememberMe = true;
    this.verifyCode();
  }

  handleRememberMeNot() {
    this.rememberMe = false;
    this.verifyCode();
  }

  handleSubmitError(error: errorType) {
    this.codeChange('');
    this.errorAttempts = false;

    switch (error.UserMessage) {
      // cases 'Account lockedout.', 'Account lockedout with reset.' and 'Internal server error.' are taken care of in error.interceptor.ts
      case 'Invalid login attempt.':
        if (error.LockOutEndsMessage) {
          this.errorMsg = 'Exceeded attempt limit. Please try again after ' + error.LockOutEndsMessage + ' or go to forgot username or password.';
        } else {
          this.errorMsg = error.UserMessage;
        }
        break;
      case 'Invalid token.':
        if (error.MaxAttempt && error.CurrentAttempt) {
          this.errorMsg = "\nThis account will be locked after " + (error.MaxAttempt - error.CurrentAttempt) + " more attempt(s).";
        }
        $('.pincode-input > input').val("");
        this.errorAttempts = true;
        break;
      case 'Unable to send token.':
        this.errorMsg = "Sorry, we were not able to reach the " + (this.selectedProvider?.type === 'phone' ? "mobile number" : "mail id") + " you provided";
        break;
      case 'Two factor challenge timeout.':
        this.timeOut.emit(error);
        break;
      case '':
        this.errorMsg = 'Something went wrong. Please try again.';
        break;
      default:
        this.errorMsg = error.UserMessage;
    }
  }
}
